import { render, staticRenderFns } from "./LoginInfoContainerBody.vue?vue&type=template&id=27172494&"
import script from "./LoginInfoContainerBody.vue?vue&type=script&lang=js&"
export * from "./LoginInfoContainerBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports